module.exports = __webpack_public_path__ + "static/media/LeagueSpartan-Medium.540bc83d.ttf";